import React, {useContext} from 'react'
import {ToastMessageContext} from '../../context/ToastMessage'
import PopMessage from './PopMessage'
import ToastMessage from './ToastMessage'

function BarcodeToastMessage() {
  const toast = useContext(ToastMessageContext)

  return toast.messages.map((e, i, arr) =>
    e.elRef ? (
      <PopMessage
        {...e}
        index={i}
        key={i}
        handleExited={toast.handleExited}
        handleClose={toast.handleClose}
      />
    ) : (
      <ToastMessage
        {...e}
        index={i}
        key={i}
        handleExited={toast.handleExited}
        handleClose={toast.handleClose}
      />
    )
  )
}

export default BarcodeToastMessage
